import { render, staticRenderFns } from "./SocialMediaCarousel.vue?vue&type=template&id=7c7e6b07&scoped=true&"
import script from "./SocialMediaCarousel.vue?vue&type=script&lang=js&"
export * from "./SocialMediaCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaCarousel.vue?vue&type=style&index=0&id=7c7e6b07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e6b07",
  null
  
)

export default component.exports